module.exports = __webpack_public_path__ + "img/4.ed2e37b5.jpg";